import { d as r } from "./descriptors.js";
import { i as t } from "./is-array.js";
var e = TypeError,
  n = Object.getOwnPropertyDescriptor,
  o = r && !function () {
    if (void 0 !== this) return !0;
    try {
      Object.defineProperty([], "length", {
        writable: !1
      }).length = 1;
    } catch (r) {
      return r instanceof TypeError;
    }
  }() ? function (r, o) {
    if (t(r) && !n(r, "length").writable) throw e("Cannot set read only .length");
    return r.length = o;
  } : function (r, t) {
    return r.length = t;
  };
export { o as a };